<div
  [attr.title]="rating()"
  class="flex gap-1">
  @for (star of stars(); let index = $index; track index) {
    <app-icon [icon]="icon(star)" />
  }
</div>
